import { routes as pcoContaCorrente } from "../prestacaocontas/pcocontacorrente";
import { routes as pcoOrigemRecurso } from "../prestacaocontas/pcoorigemrecurso";
import { routes as pcoPlanoContas } from "../prestacaocontas/pcoplanocontas";
import { routes as pcoProjeto } from "../prestacaocontas/pcoprojeto";
import { routes as pcoEmpenho } from "../prestacaocontas/pcoempenho";
import { routes as pcoDotacaoOrcamentaria } from "../prestacaocontas/pcodotacaoorcamentaria";
import { routes as pcoAcao } from "../prestacaocontas/pcoacao";
import { routes as pcoProjetoRepasse } from "../prestacaocontas/pcoprojetorepasse";
import { routes as pcoPlanejamento } from "../prestacaocontas/pcoplanejamento";
import { routes as pcoMovimentacao } from "../prestacaocontas/pcomovimentacao";
import { routes as pcoConciliacaoBancaria } from "../prestacaocontas/pcoconciliacaobancaria";
import { routes as pcoProjetoPrestacaoContas } from "../prestacaocontas/pcoprojetoprestacaocontas";
import { routes as pcoProjetoDiligencia } from "../prestacaocontas/pcoprojetodiligencia";

export default [
  {
    path: "/prestacaocontas",
    name: "PrestacaoContas",
    description: "Modulo Prestacao de Contas",
    children: [
      ...pcoContaCorrente,
      ...pcoOrigemRecurso,
      ...pcoPlanoContas,
      ...pcoProjeto,
      ...pcoEmpenho,
      ...pcoDotacaoOrcamentaria,
      ...pcoAcao,
      ...pcoProjetoRepasse,
      ...pcoPlanejamento,
      ...pcoMovimentacao,
      ...pcoConciliacaoBancaria,
      ...pcoProjetoPrestacaoContas,
      ...pcoProjetoDiligencia,
    ],
    goesToMenu: true,
  },
];
